import { AFTER_MUTATION } from "./afterMutation";
import { invalidateDepositRecordViews } from "./depositRecordQueries";
// A merge rewrites every view of a title, so one place lists the keys and no call site can forget one.
export var invalidateAfterTitleMerge = function (queryClient) {
    [
        "titlesWithIsbn",
        "titlesWithoutIsbn",
        "titlesForVerification",
        "title",
        "title-detail",
        "title-enforcement-detail",
        "cross-library-history",
        "investigationNotes",
        "title-library-note-dialog",
        "periodicalLibraries",
        "title-duplicate-groups",
        "title-merges",
        "title-merge-comparison",
        "title-merge-preview",
        "title-merge-candidates",
    ].forEach(function (key) {
        return queryClient.invalidateQueries([key], undefined, AFTER_MUTATION);
    });
    invalidateDepositRecordViews(queryClient);
};
